var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4799 11.1114C18.2171 10.778 17.8972 10.4891 17.6001 10.2002C16.8345 9.53355 15.9661 9.05576 15.2348 8.35574C13.5323 6.73347 13.1552 4.05561 14.2407 2C13.1552 2.25556 12.2068 2.83336 11.3955 3.46671C8.43605 5.77789 7.27055 9.85578 8.66458 13.3559C8.71029 13.467 8.75599 13.5781 8.75599 13.7226C8.75599 13.967 8.5846 14.1892 8.35607 14.2781C8.09326 14.3892 7.81902 14.3226 7.60192 14.1448C7.53707 14.092 7.48283 14.0279 7.44195 13.9559C6.15076 12.367 5.94508 10.0891 6.81349 8.26685C4.90527 9.778 3.86546 12.3336 4.01401 14.7448C4.08256 15.3004 4.15112 15.856 4.34537 16.4115C4.50534 17.0782 4.81386 17.7449 5.15665 18.3338C6.39071 20.2561 8.52746 21.6339 10.8242 21.9117C13.2695 22.2117 15.8861 21.7783 17.7601 20.1339C19.8511 18.2894 20.5824 15.3337 19.5083 12.8003L19.3598 12.5114C19.1198 12.0003 18.4799 11.1114 18.4799 11.1114ZM14.8692 18.1116C14.5492 18.3782 14.0236 18.6671 13.6122 18.7783C12.3325 19.2227 11.0527 18.6005 10.2986 17.8671C11.6583 17.556 12.4696 16.5782 12.7096 15.5893C12.9038 14.7004 12.5382 13.967 12.3896 13.1114C12.2525 12.2892 12.2753 11.5892 12.5839 10.8225C12.801 11.2447 13.0295 11.6669 13.3037 12.0003C14.1836 13.1114 15.5662 13.6003 15.8633 15.1115C15.909 15.267 15.9318 15.4226 15.9318 15.5893C15.9661 16.5004 15.5547 17.5004 14.8692 18.1116Z",
    fill: "#15318D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2);
export default __webpack_public_path__ + "static/media/e2.36bd43e1adfee7895e9b233ef4d6c259.svg";
export { ForwardRef as ReactComponent };